// extracted by mini-css-extract-plugin
export default {"modal":"ConnectModal_modal__fC9Un","title":"ConnectModal_title__BgL8C","subtitle":"ConnectModal_subtitle__IUqtb","buttons":"ConnectModal_buttons__LMGvL"};